import styled from 'styled-components';
import {SquarePen} from 'lucide-react';

export const CodesVerificationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
`;

export const CodesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  align-items: center;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  position: relative;
  padding-top: 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`;

export const ChangeContactsButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 12px 0;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ChangeContactsIcon = styled(SquarePen)`
  color: ${props =>
    props.theme.hasTemplate ? props.theme.colors.buttons.textButton : '#385BF8'};
  width: 24px;
  height: 24px;
`;

export const ChangeContactsText = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.15px;
  color: #385bf8;
`;
